module.exports = __webpack_public_path__ + "static/media/impact_narrative_feature.59a75764.png";